import { Component, OnInit } from '@angular/core';
import { Pagination } from '../../../models/pagination';
import { CompaniesService } from '../../../services/companies.service';
import { Client } from '../../../models/client';
import { Store } from '@ngxs/store';
import { ClientSelected } from '../../../state/ClientSelectionState/ClientSelection.state';
import { Navigate } from '@ngxs/router-plugin';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.css'],
  standalone: false
})
export class ClientListComponent implements OnInit {
  clients: Client[];
  pagination: Pagination;

  constructor(
    public companyService: CompaniesService,
    private store: Store
  ) {}

  ngOnInit() {
    this.companyService.searchCompanies().subscribe(resp => {
      this.clients = resp.Items;
      this.pagination = resp.Pagination;
    });
  }

  loadPage({ Page }: Pagination) {
    this.companyService.searchCompanies({ pageNumber: Page }).subscribe(resp => {
      this.clients = resp.Items;
      this.pagination = resp.Pagination;
    });
  }

  navigateToClient(clientCode) {
    this.store.dispatch(new ClientSelected(clientCode)).subscribe(_ => {
      this.store.dispatch(new Navigate([`/client/${clientCode}`]));
    });
  }
  navigateToClientNotes(clientCode) {
    this.store.dispatch(new ClientSelected(clientCode)).subscribe(_ => {
      this.store.dispatch(new Navigate([`/client/${clientCode}/notes`]));
    });
  }
}
